// @ts-nocheck
import config from "constants/config";

import { useGet as Get } from "./useRequest";

export function getEmployeeAuthorisation(companyId) {
  if (!companyId) {
    return Promise.resolve([]);
  }
  const response = Get(`/realms/${config.realm}/qjumpers/companies/${companyId}/employeeauthorisation`, "KEYCLOAK");
  return response;
}

export const useGetCompanyDetails = (userId) => {
  const response = Get(`/realms/${config.realm}/qjumpers/users/${userId}/companies`, "KEYCLOAK");
  return response;
};

export function getOrganisationCheck(companyId) {
  if (!companyId) {
    return Promise.resolve([]);
  }
  const response = Get(`/organisations/check/${companyId}`);
  return response;
}

export function getOrganisation(companyId) {
  if (!companyId) {
    return Promise.resolve([]);
  }
  const response = Get(`/organisations/${companyId}`);
  return response;
}

export function getBrowserToken(employerId) {
  const response = Get(`/authentication/${employerId}/browsertoken`);
  return response;
}
